/*
* This store holds the data for the course-options page of the calcualtor
*
*/
const axios = require('axios')

const state = {
   updatingFees: false,
   fees: null,
   errorFees: null,
}

const mutations = {
   setUpdatingFees(state,  data) {
      state.updatingFees = data;
  },

  setFees(state, data) {
      state.fees = data;
  },

  setErrorFees(state, data) {
      state.errorFees = data;
  },
}

const actions = {
   fetchFees({state, commit, rootState, rootGetters},  stuCode) {
      commit('setUpdatingFees', true)
      commit('setErrorFees', null)
      axios.post(BaseURL + '/api/fees/fetchFees/', { stuCode })
         .then(response => {
            commit('setFees', response.data)
         })
         .catch(err => {
            let error = err.response.status + " - " + err.response.statusText
            commit('setErrorFees', error)
         }).finally(() =>{
            commit('setUpdatingFees', false)
         })
   },
   fetchStudentTypes({state, commit, rootState, rootGetters},  keywords) {
      return new Promise((resolve, reject) => {
         axios
         .post(BaseURL + '/api/fees/getStudentTypes/')
         .then(response => {
            resolve(response.data)
         })
         .catch(err => {
            let error = err.response.status + " - " + err.response.statusText
            reject(error);
         });
      })
   },
}

export default {
    state,
    actions,
    mutations
}
